// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#bbb","whyUsBriefColor":"#747474","linkColorDefault":"#000","buttonBgColorDefault":"#eb7f58"};